import PageModule from "@eisinc/Overrides/Pages/HomePage";

export * from "@eisinc/Overrides/Pages/HomePage";

export default PageModule;
